import { Module } from '@nestjs/common';
import { MailModule } from '../mail/mail.module';
import { PedidosModule } from '../pedidos/pedidos.module';
import { PresupuestoPublicoController } from './presupuesto-publico.controller';
import { PresupuestosAprobacionService } from './presupuestos-aprobacion.service';
import { PresupuestosConversionService } from './presupuestos-conversion.service';
import { PresupuestosCron } from './presupuestos.cron';
import { PresupuestosController } from './presupuestos.controller';
import { PresupuestosDashboardService } from './presupuestos-dashboard.service';
import { PresupuestosPdfService } from './presupuestos-pdf.service';
import { PresupuestosPublicoService } from './presupuestos-publico.service';
import { PresupuestosService } from './presupuestos.service';

@Module({
  imports: [MailModule, PedidosModule],
  controllers: [PresupuestosController, PresupuestoPublicoController],
  providers: [
    PresupuestosService,
    PresupuestosPdfService,
    PresupuestosPublicoService,
    PresupuestosAprobacionService,
    PresupuestosConversionService,
    PresupuestosDashboardService,
    PresupuestosCron,
  ],
  exports: [PresupuestosService, PresupuestosPdfService],
})
export class PresupuestosModule {}
